import React from 'react'
import {observer, inject} from 'mobx-react'
import styled from 'styled-components'
import {Stores} from '../stores'
import {CandidateStore} from '../stores/CandidateStore'
import {PartyStore} from '../stores/PartyStore'
import {imagePrefix} from '../stores/config'

interface IProps {
  candidateStore?: CandidateStore
  partyStore?: PartyStore
}

function CandidateInfo({candidateStore, partyStore}: IProps) {
  const {candidate, consistuencyName = ''} = candidateStore!
  if (!candidate) return null

  const getParty = (partyId: number) => {
    return partyStore?.parties?.find(p => p.id === partyId) || {name: ''}
  }

  const getPartyName = () => {
    if (!Object.keys(candidate.election_data || {}).length) {
      const {name: partyName} = getParty(candidate.party_id)
      return candidate.independent ? `${partyName} (sit.)` : partyName
    }

    const {election_data} = candidate
    const cPartyId = election_data?.county?.party_id
    const mPartyId = election_data?.municipality?.party_id

    if (!cPartyId && !mPartyId) {
      return ''
    } else if (cPartyId && mPartyId) {
      return cPartyId === mPartyId ? getParty(cPartyId).name : `${getParty(mPartyId).name} | ${getParty(cPartyId).name}`
    } else {
      const partyId = cPartyId || mPartyId
      return partyId ? getParty(partyId).name : ''
    }
  }

  const {first_name, last_name, image} = candidate

  return (
    <CandidateInfoContainer>
      <CandidateData>
        <Name>{`${first_name} ${last_name}`}</Name>
        <Constituency>{consistuencyName}</Constituency>
        <div>{getPartyName()}</div>
      </CandidateData>
      {image && (
        <ImageContainer>
          <img src={`${imagePrefix}/${image}`} />
        </ImageContainer>
      )}
    </CandidateInfoContainer>
  )
}

export default inject((stores: Stores) => ({candidateStore: stores.candidateStore, partyStore: stores.partyStore}))(observer(CandidateInfo))

const CandidateInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const ImageContainer = styled.div`
  border-radius: 50%;
  img {
    height: 12rem;
    border-radius: 50%;
  }
`

const CandidateData = styled.div`
  display: flex;
  flex-direction: column;
`

const Constituency = styled.div``

const Name = styled.div`
  font-size: 24px;
  font-weight: bold;
`
